import { Panel } from '@studiometa/ui';

/**
 * PanelSize component
 */
export default class PanelSize extends Panel {
  static config = {
    ...Panel.config,
    name: 'PanelSize',
    options: {
      ...Panel.config.options,
      styles: {
        type: Object,
        /**
         * @returns {object}
         */
        default: () => ({
          modal: {
            closed: {
              opacity: '0',
              pointerEvents: 'none',
              visibility: 'hidden',
            },
            open: {
              opacity: '1',
              pointerEvents: 'auto',
              visibility: 'visible',
            },
          },
          overlay: {
            closed: 'opacity-0',
          },
          container: {
            closed: 'translate-x-full',
          },
        }),
      },
    },
  };
}
